import * as React from 'react';

import type { DisplayViewPlaceholderViewModel } from 'ab-viewModels/scheduleBoardDisplayView.viewModel';

import * as ColorUtils from 'af-utils/color.util';

import SkillsColorGrid from 'af-components/SkillsColorGrid';

interface OwnProps {
	placeholder: DisplayViewPlaceholderViewModel;
}

type Props = OwnProps;

const PlaceholderItem: React.FC<Props> = (props: Props) => {
	const { displayName, skills, categoryColor } = props.placeholder;

	return (
		<div className="sb-resource-item sb-resource-item--placeholder">
			<div className="sb-resource-item__content">
				<span className="sb-resource-item__full-name sb-resource-item__full-name--transparent-bg">{displayName}</span>
				{!!skills?.length && <SkillsColorGrid skills={skills} />}
				{!!categoryColor && <div className={`sb-resource-item__category-color-preview ${ColorUtils.getColorBackgroundClass(categoryColor, true)}`} />}
			</div>
		</div>
	);
};

export default React.memo(PlaceholderItem);
